import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import NavigationBar from "../layout/NavigationBar";
import Footer from "../layout/footer";
import "datatables.net-dt/css/jquery.dataTables.css"; // Required for styling
import $ from "jquery"; // Required for jQuery to work with DataTable
import "datatables.net"; // Import DataTable jQuery plugin

function Contacts() {
  const navigate = useNavigate();
  const location = useLocation(); // Access the current location (URL)
  const [requestData, setRequestData] = useState([]); // Initialize as an empty array
  const [dataTable, setDataTable] = useState(null);
  const [user, setUser] = useState();
  // Extract query parameter 'id' from the URL
  const queryParams = new URLSearchParams(location.search);
  const userId = queryParams.get("id"); // Get the 'id' from the query string
  const Type = queryParams.get("type"); // Get the 'id' from the query string

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (Array.isArray(requestData) && requestData.length > 0) {
      // Check if the table element exists and is rendered
      if ($("#contact").length) {
        // Destroy any existing DataTable instance before reinitializing
        if (dataTable) {
          dataTable.destroy(true); // Ensure it destroys the previous table instance
        }

        // Initialize the DataTable after data is set
        requestAnimationFrame(() => {
          const table = $("#contact").DataTable({
            data: requestData,
            columns: [
              { data: null, render: (data, type, row, meta) => meta.row + 1 },
              {
                data: "mobile",
                render: (data, type, row) => {
                  // Check if both countryCode and mobile exist in row data
                  const countryCode = row?.countryCode
                    ? `${row.countryCode}`
                    : "N/A";
                  const mobile = data || "N/A"; // Fallback to 'N/A' if mobile is not available
                  return `${countryCode} ${mobile}`;
                },
              },
              {
                data: "deviceType",
                render: (data) =>
                  data ? data.charAt(0).toUpperCase() + data.slice(1) : "N/A",
              },
              {
                data: "createdAt",
                render: (data) => new Date(data).toLocaleString() || "N/A",
              },
            ],
            pageLength: 5,
            lengthMenu: [5, 10, 25, 50, 75, 100],
            responsive: true,
          });

          setDataTable(table);
        });
      }
    }
  }, [requestData]); // Only run this effect when `requestData` changes

  const fetchData = async () => {
    try {
      const response = await axios({
        method: "POST",
        url: process.env.REACT_APP_APIURL,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          environment: "live",
          apikey: process.env.REACT_APP_APIKEY,
          secret: process.env.REACT_APP_SECRET,
          method: "userAdditionalInfo",
          module: "user",
          userId: userId,
        }),
      });

      const data = response.data;
      if (data.statusCode === 200) {
        setUser(data.result.userDetails[0].user);
        setRequestData(Type ==='refer'?data.result.userDetails[0].referedBy:
          data.result.userDetails[0].contacts || [] // Default to 'createdGeotags'
        );
      } else {
        console.error("Failed to fetch contacts:", data);
        setRequestData([]); // Clear data if fetching fails
      }
    } catch (error) {
      console.error("Error fetching geotag data:", error);
      setRequestData([]); // Clear data if there's an error
    }
  };

  return (
    <div className="wrapper">
      <header>
        <NavigationBar />
      </header>

      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0 txt_lft">{Type ==='refer'?"Referrals by link":"Contacts"} - ({user?.countryCode || ""}{user?.mobile || ""})</h1>
              </div>
            </div>
          </div>
        </div>

        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                {/* Conditional rendering for "No records" message */}
                {requestData.length === 0 ? (
                  <p>No Contacts found.</p> // Display message if no data
                ) : (
                  <div className="table-responsive">
                    <table
                      id="contact"
                      className="table table-striped table-bordered txt_lft"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                        <th>S.No</th>
                        <th>Phone</th>
                        <th>Device Type</th>
                        <th>CreatedAt</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* Data rows will be populated by DataTable */}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Contacts;
